import { render, staticRenderFns } from "./BreakdownReport.vue?vue&type=template&id=456dadd3"
import script from "./BreakdownReport.vue?vue&type=script&lang=js"
export * from "./BreakdownReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports